module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"placeholder":{"first_name":"Cecília","last_name":"Meireles","full_name":"Escola Projeto Vida"}}}')
  delete Component.options._Ctor
}
